const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/uster/branding/theme.ts';
import { colors } from '@cistec/common_web/defs/colors';
import { PatAppTheme } from '../../common/branding/theme';

/**
 * This is the theme object which should be used for material ui components and also non-material ui components
 * Source: https://material-ui.com/customization/default-theme/
 */

interface customTheme {
    [key: string]: customTheme | string | number;
}

export const theme: PatAppTheme = {
    breakpoints: {
        values: {
            xs: 480,
            sm: 600,
            md: 840,
            lg: 1280,
            xl: 1920,
        },
    },
    palette: {
        common: colors.common,
        primary: {
            main: '#0675b2',
        },
        secondary: {
            main: colors.blue['700'],
        },
        error: {
            main: colors.red.A400,
            contrastText: colors.common.white,
        },
        warning: {
            light: colors.orange.A200,
            main: colors.orange.A400,
            dark: colors.orange.A700,
        },
        info: {
            main: '#00a5ef',
        },
        success: {
            main: colors.green.A400,
        },
        grey: { ...colors.grey },
        background: {
            paper: colors.common.white,
            default: colors.blue['100'],
        },
    },
    custom: {
        gradientLoginPage: `linear-gradient(135deg, ${colors.blue['100']} 0%, ${colors.blue['500']} 100%)`,
        progressNotDone: colors.blue['700'],
    },
    typography: {
        h1: {
            fontSize: '1.14rem',
            fontWeight: 500,
        },
        h2: {
            fontSize: '1.8rem',
            // color: colors.teal['600'],
        },
        h5: {
            fontSize: '1rem',
            fontWeight: 400,
        },
        h6: {
            fontSize: '1.14rem',
        },
        subtitle1: {
            fontSize: '1.5rem',
        },
    },
};
